import { Values } from '@lib/interfaces/form';
import ApiTokenFieldNames from '@lib/enums/fieldNames/apiTokenFieldNames';

export default function getDefaultValuesFromQueryData(data?: Values): Values {
  return {
    [ApiTokenFieldNames.Label]: data?.label ?? null,
  };
}
